import React from "react";
import CenterModal from "../UI/Modal/CenterModal";
import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";
import { setConfirmMediateTheCall } from "../../reducers/silentObserver-reducer";
import { callEndWithMediate } from "./SilentObserverUtils";

const MediatePopup = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const { confirmMediateTheCall } = useSelector((state) => state.silentObserver);

    const handleCloseModal = () => {
        dispatch(setConfirmMediateTheCall(false));
    };

    const modalHeader = (
        <>
            <h5 className='modal-title'>{localisedValues["join_as_mediator_title"]}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={handleCloseModal}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const modalBody = (
        <div className='cms-modal-text'>
            <p>{localisedValues["join_as_mediator_popup_description"]}</p>
        </div>
    );

    const modalFooter = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-link' onClick={handleCloseModal}>
                    {localisedValues["cancel"]}
                </button>
            </div>
            <div className='button'>
                <button className='btn default-btn-primary' onClick={() => callEndWithMediate("endCallWithMediate")}>
                    {localisedValues["confirm"]}
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={confirmMediateTheCall}
            closeModal={() => handleCloseModal()}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog modal-dialog-centered'
            header={modalHeader}
            body={modalBody}
            footer={modalFooter}
            backdrop={"static"}
        />
    );
};

export default MediatePopup;
